// 目标对象 fieldKey 常量
const TARGET_OBJECT_MEDIA = '3'; // 媒体
const TARGET_OBJECT_OTHER = '4'; // 其它

// 目标对象"其它"的 fieldValue（后端枚举固定值，用于详情组件无 fieldKey 时的判断）
export const TARGET_OBJECT_OTHER_VALUE = '其它';

/**
 * 格式化目标对象显示文本
 * @param {string} targetObject - 目标对象值
 * @param {string} targetObjectOther - 其它目标对象内容
 * @param {Function} $t - i18n 翻译函数
 * @returns {string}
 */
export function formatTargetObjectDisplay (targetObject, targetObjectOther, $t) {
  if (targetObject === TARGET_OBJECT_OTHER_VALUE && targetObjectOther) {
    return $t('newApp.activityInfo.otherTargetObjectFormat', { content: targetObjectOther });
  }
  return targetObject;
}

/**
 * 详情/汇总组件用 mixin，提供 formatTargetObject 方法供模板调用
 */
export const targetObjectDisplayMixin = {
  methods: {
    formatTargetObject (targetObject, targetObjectOther) {
      return formatTargetObjectDisplay(targetObject, targetObjectOther, this.$t.bind(this));
    }
  }
};

export default {
  computed: {
    // 过滤后的目标对象选项列表
    filteredTargetObjectList () {
      const isSimplifiedUI = this.$store.state.useSimplifiedForm;
      if (!this.targetObjectList) return [];
      return this.targetObjectList.filter(item => {
        if (item.fieldKey === TARGET_OBJECT_MEDIA && isSimplifiedUI) return false;
        if (item.fieldKey === TARGET_OBJECT_OTHER && !isSimplifiedUI) return false;
        return true;
      });
    },
    // 当前选中的目标对象是否为"其它"
    isTargetObjectOther () {
      if (!this.targetObjectList || !this.formData.targetObject) return false;
      const selected = this.targetObjectList.find(
        item => item.fieldValue === this.formData.targetObject
      );
      return selected ? selected.fieldKey === TARGET_OBJECT_OTHER : false;
    }
  }
};
